import { useTranslation } from "react-i18next";
import { QuizAnswerReview } from "./QuizAnswerReview";
import type {
  FormResponseDetail,
  QuizResponseDetail,
  ReflectionResponseDetail,
  TeacherPDDayItem,
} from "../types";

// content_progress only tells us "completed at 100%" — for quiz/form/
// reflection items that hides the graded, gradeable part of the story
// (what was actually answered), so those three types render their full
// response instead of the generic status line every other type keeps.
export function TeacherPDDayItemRow({ item }: { item: TeacherPDDayItem }) {
  const { t } = useTranslation();

  return (
    <article className="grid gap-2 py-3">
      <strong className="text-sm font-semibold text-app-ink">{item.title}</strong>

      {item.type === "quiz" && item.response ? (
        <QuizAnswerReview quiz={item.response as QuizResponseDetail} />
      ) : item.type === "form" && item.response ? (
        <FormAnswerReview form={item.response as FormResponseDetail} />
      ) : item.type === "reflection" && item.response ? (
        <ReflectionAnswerReview reflection={item.response as ReflectionResponseDetail} />
      ) : (
        <span className="text-sm text-app-copy">
          {t(item.status === "completed" ? "historyDone" : "historyStarted")}
        </span>
      )}

      {(item.type === "quiz" || item.type === "form" || item.type === "reflection") &&
        !item.response && <span className="text-sm text-app-muted">{t("notSubmitted")}</span>}
    </article>
  );
}

function FormAnswerReview({ form }: { form: FormResponseDetail }) {
  const { t } = useTranslation();
  if (form.fields.length === 0) {
    return <span className="text-sm text-app-muted">{t("notSubmitted")}</span>;
  }
  return (
    <div className="flex flex-col gap-1.5 rounded-lg bg-app-field p-3">
      {form.fields.map((field) => (
        <div key={field.field_id} className="grid gap-0.5">
          <span className="text-xs font-medium text-app-muted">{field.label}</span>
          <span className="text-sm text-app-ink">{String(field.value)}</span>
        </div>
      ))}
    </div>
  );
}

function ReflectionAnswerReview({ reflection }: { reflection: ReflectionResponseDetail }) {
  const { t } = useTranslation();
  return (
    <div className="rounded-lg bg-app-field p-3">
      <span className="text-xs font-medium text-app-muted">{t("yourResponse")}</span>
      <p className="mt-0.5 text-sm text-app-ink">{reflection.response_text}</p>
    </div>
  );
}
